<template>
  <div class="user">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="审核状态">
          <el-select v-model="formInline.apply_status" placeholder="请选择状态">
            <el-option label="全部" value="-1"></el-option>
            <el-option label="待审核" value="10"></el-option>
            <el-option label="审核通过" value="20"></el-option>
            <el-option label="已打款" value="40"></el-option>
            <el-option label="驳回" value="30"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提现方式">
          <el-select v-model="formInline.pay_type" placeholder="请选择提现方式">
            <el-option label="全部" value="-1"></el-option>
            <el-option label="微信" value="10"></el-option>
            <el-option label="支付宝" value="20"></el-option>
            <el-option label="银行卡" value="30"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户id">
          <el-input v-model="formInline.user_id" placeholder="请输入用户ID"></el-input>
        </el-form-item>
        <el-form-item label=""><el-input v-model="formInline.search" placeholder="昵称/姓名/手机号"></el-input></el-form-item>
        <el-form-item><el-button type="primary" @click="onSubmit">查询</el-button></el-form-item>
        <el-form-item>
          <el-button size="small" type="success" @click="onExport" v-auth="'/user/cash/export'">导出</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="product-content">
      <div class="table-wrap">
        <el-table :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="user_id" label="用户ID" width="60"></el-table-column>
          <el-table-column prop="nickName" label="微信头像" width="70">
            <template slot-scope="scope">
              <img class="radius" v-img-url="scope.row.avatarUrl" width="30" height="30" />
            </template>
          </el-table-column>
          <el-table-column prop="nickName" label="微信昵称" width="100"></el-table-column>
          <el-table-column prop="money" label="提现金额">
            <template slot-scope="scope">
              <span class="orange">{{ scope.row.money }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="money" label="实际到账">
            <template slot-scope="scope">
              <span class="orange">{{ scope.row.real_money }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="pay_type.text" label="提现方式"></el-table-column>
          <el-table-column prop="pay_type" label="提现信息">
            <template slot-scope="scope">
              <div v-if="scope.row.pay_type.value == 20">
                <p><span>支付宝名称：{{ scope.row.alipay_name }}</span></p>
                <p><span>支付宝账号：{{ scope.row.alipay_account }}</span></p>
              </div>
              <div v-else-if="scope.row.pay_type.value == 30">
                <p><span>银行名称：{{ scope.row.bank_name }}</span></p>
                <p><span>开户名：{{ scope.row.bank_account }}</span></p>
                <p><span>银行卡号：{{ scope.row.bank_card }}</span></p>
              </div>
              <div v-else>
                <p><span>--</span></p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="apply_status.text" label="审核状态"></el-table-column>
          <el-table-column prop="create_time" label="申请时间" width="135"></el-table-column>
          <el-table-column prop="audit_time" label="审核时间" width="135"></el-table-column>
          <el-table-column fixed="right" label="操作" width="180">
            <template slot-scope="scope">
              <div v-if="scope.row.apply_status.value == 10 || scope.row.apply_status.value == 20">
                <el-button type="text" size="small" @click="editClick(scope.row)" v-auth="'/user/cash/audit'">审核</el-button>
                <template v-if="scope.row.apply_status.value == 20 && scope.row.pay_type.value != 10">
                  <el-button type="text" size="small" @click="makeMoney(scope.row)" v-auth="'/user/cash/money'">确认打款</el-button>
                </template>
                <template v-if="scope.row.apply_status.value == 20 && scope.row.pay_type.value == 10">
                  <el-button type="text" size="small" @click="WxPay(scope.row.id)" v-auth="'/user/cash/wxpay'">微信付款</el-button>
                </template>
              </div>
              <div v-if="scope.row.apply_status.value == 30">
                <el-button type="text" size="small" @click="editClick(scope.row)">详情</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    <Edit v-if="open_edit" :open_edit="open_edit" :form="userModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>
  </div>
</template>

<script>
import BalanceApi from '@/api/balance.js'
import qs from 'qs'
import Edit from '@/views/user/balance/part/dialog/Edit.vue'

export default {
  components: { Edit },
  data() {
    return {
      loading: true,
      tableData: [],
      pageSize: 20,
      totalDataNumber: 0,
      curPage: 1,
      formInline: {
        search: '',
        user_id: ''
      },
      open_edit: false,
      userModel: {}
    }
  },
  watch: {
    $route(to, from) {
      if (to.query.user_id != null) {
        this.formInline.user_id = to.query.user_id
      } else {
        this.formInline.user_id = ''
      }
      this.curPage = 1
      this.getData()
    }
  },
  created() {
    if (this.$route.query.user_id != null) {
      this.formInline.user_id = this.$route.query.user_id
    }
    this.getData()
  },
  methods: {
    getData() {
      const self = this
      const Params = Object.assign({}, self.formInline, {
        page: self.curPage,
        list_rows: self.pageSize
      })
      BalanceApi.cashList(Params, true)
        .then(data => {
          self.loading = false
          self.tableData = data.data.list.data
          self.totalDataNumber = data.data.list.total
        })
        .catch(() => {})
    },
    onSubmit() {
      this.curPage = 1
      this.getData()
    },
    onExport() {
      const baseUrl = window.location.protocol + '//' + window.location.host
      window.location.href = baseUrl + '/index.php/shop/user.cash/export?' + qs.stringify(this.formInline)
    },
    handleSizeChange(val) {
      this.curPage = 1
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.curPage = val
      this.getData()
    },
    editClick(item) {
      this.userModel = item
      this.open_edit = true
    },
    closeDialogFunc(e, f) {
      if (f === 'edit') {
        this.open_edit = e.openDialog
        if (e.type === 'success') {
          this.getData()
        }
      }
    },
    makeMoney(e) {
      this.$confirm('确认要打款吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          BalanceApi.cashMoney({ id: e.id }, true)
            .then(data => {
              this.loading = false
              if (data.code == 1) {
                this.$message.success('操作成功')
                this.getData()
              }
            })
            .catch(() => {
              this.loading = false
            })
        })
        .catch(() => {})
    },
    WxPay(id) {
      this.$confirm('该操作将使用微信支付企业付款到零钱功能，确定打款吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          BalanceApi.cashWxpay({ id }, true)
            .then(data => {
              this.loading = false
              if (data.code == 1) {
                this.$message.success('操作成功')
                this.getData()
              }
            })
            .catch(() => {
              this.loading = false
            })
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.radius {
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/views/distribution/cash.vue